// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { NormalGroupControl, NormalGroupControlT } from "./normal-group-control";
import { ValuedGroupControl, ValuedGroupControlT } from "./valued-group-control";

export enum GroupControlVariant {
  NONE = 0,
  NormalGroupControl = 1,
  ValuedGroupControl = 2,
}

export function unionToGroupControlVariant(
  type: GroupControlVariant,
  accessor: (
    obj: NormalGroupControl | ValuedGroupControl,
  ) => NormalGroupControl | ValuedGroupControl | null,
): NormalGroupControl | ValuedGroupControl | null {
  switch (GroupControlVariant[type]) {
    case "NONE":
      return null;
    case "NormalGroupControl":
      return accessor(new NormalGroupControl())! as NormalGroupControl;
    case "ValuedGroupControl":
      return accessor(new ValuedGroupControl())! as ValuedGroupControl;
    default:
      return null;
  }
}

export function unionListToGroupControlVariant(
  type: GroupControlVariant,
  accessor: (
    index: number,
    obj: NormalGroupControl | ValuedGroupControl,
  ) => NormalGroupControl | ValuedGroupControl | null,
  index: number,
): NormalGroupControl | ValuedGroupControl | null {
  switch (GroupControlVariant[type]) {
    case "NONE":
      return null;
    case "NormalGroupControl":
      return accessor(index, new NormalGroupControl())! as NormalGroupControl;
    case "ValuedGroupControl":
      return accessor(index, new ValuedGroupControl())! as ValuedGroupControl;
    default:
      return null;
  }
}

export type GroupControlVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalGroupControl"; value: NormalGroupControlT }
  | { type: "ValuedGroupControl"; value: ValuedGroupControlT };
